import { Fragment } from 'react';
import { DigitalRow } from '../../types';
import { DigitalBudgetSectionProps, TouchpointGroup } from './types';
import DigitalTouchpointSection from './DigitalTouchpointSection/DigitalTouchpointSection';

function groupDigitalRowsByTouchpointAndFunnel(
  digitalRows: DigitalRow[]
): TouchpointGroup[] {
  const tpMap = new Map<
    string,
    { rows: DigitalRow[]; funnels: Map<string, DigitalRow[]> }
  >();

  digitalRows.forEach((row) => {
    const tpName = row.touchpointName;
    if (!tpMap.has(tpName)) {
      tpMap.set(tpName, { rows: [], funnels: new Map() });
    }
    const tp = tpMap.get(tpName)!;
    tp.rows.push(row);

    const funnelName = row.touchpointFunnel || 'Other';
    if (!tp.funnels.has(funnelName)) {
      tp.funnels.set(funnelName, []);
    }
    tp.funnels.get(funnelName)!.push(row);
  });

  return Array.from(tpMap.entries()).map(
    ([touchpointName, { rows, funnels }]) => ({
      touchpointName,
      rows,
      funnels: Array.from(funnels.entries()).map(([funnelName, fRows]) => ({
        funnelName,
        rows: fRows,
      })),
    })
  );
}

export default function DigitalBudgetSection({
  country,
  plans,
  formatBudget,
  getDigitalRowsForCountry,
  getDigitalEntry,
  getPriorityLabel,
  showOnlyDifferences,
}: DigitalBudgetSectionProps) {
  const digitalRows = getDigitalRowsForCountry(plans, country);
  const touchpointGroups = groupDigitalRowsByTouchpointAndFunnel(digitalRows);

  return (
    <>
      {touchpointGroups.map((tp) => (
        <Fragment key={tp.touchpointName}>
          <DigitalTouchpointSection
            country={country}
            plans={plans}
            formatBudget={formatBudget}
            showOnlyDifferences={showOnlyDifferences}
            group={tp}
            getDigitalEntry={getDigitalEntry}
            getPriorityLabel={getPriorityLabel}
          />
        </Fragment>
      ))}
    </>
  );
}
